import { z } from 'zod';

export const loginSchema = z.object({
    username: z.string().min(1),
    password: z.string().min(1)
});

export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(1)
});

export const createUserSchema = z.object({
    userName: z.string().min(1),
    password: z.string().min(1),
    admin: z.boolean()
});

export const updateUserSchema = z.object({
    userName: z.string().min(1).optional(),
    admin: z.boolean().optional()
});
